export const to = async <T>(promise: Promise<any>): Promise<[any, T]> => {

    try {
        let data = await promise;
        console.log({ data });
        return [undefined, data];
    } catch (exception) {
        console.log({ exception });

        return [exception, undefined];
    }
}